export default "__VITE_ASSET__DzjZcKZE__"